module.exports = "/_next/static/images/BundleOfferMain-3fba872bdd3255549c58edc35950480b.png";